import React from 'react';

import { ReactComponent as ProfileIcon } from "./assets/icons/profileIcon.svg";
import { ReactComponent as BankIcon } from "./assets/icons/bankingIcon.svg";
import { ReactComponent as LogoutIcon } from "./assets/icons/logoutIcon.svg";

export const MENU_ITEMS = [
    {
        id: "profile",
        label: "profile.management.menu.personaldetails.label",
        route: "/settings",
        icon: <ProfileIcon />
    },
    {
        id: "bankDetails",
        label: "profile.management.menu.bankdetails.label",
        route: "/refer",
        icon: <BankIcon />
    },
    {
        id: "logout",
        label: "profile.management.menu.logout.label",
        route: "/refer",
        icon: <LogoutIcon />
    },
];